var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1RowBet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.496,
    height: 16.798,
    viewBox: "0 0 32.496 16.798",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 0.614,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f0057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f0057",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape_Copy_4",
    "data-name": "Combined Shape Copy 4",
    d: "M9.07,16.553.378,9.22a1.084,1.084,0,0,1,0-1.645L9.07.24a1.03,1.03,0,0,1,1.686.823V15.73A1.048,1.048,0,0,1,9.719,16.8,1,1,0,0,1,9.07,16.553ZM27.338,13.8V3.164H32.5V13.8Zm-7.223,0V3.164h5.159V13.8Zm-7.222,0V3.164h5.159V13.8Z",
    transform: "translate(0 0.002)",
    opacity: 0.8,
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1RowBet);
export default __webpack_public_path__ + "static/media/1_row_bet.fd90183d0dcbf32a3395893207d21d7f.svg";
export { ForwardRef as ReactComponent };